import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { TooltipDirective } from "src/app/shared/components/ui/tooltip.directive";
import { PaginationModel } from "src/app/shared/models/common";
import { DrProfile } from "src/app/shared/models/order.model";

@Component({
  selector: "dr-profile-list",
  templateUrl: "./dr-profile-list.component.html",
  styleUrls: ["./dr-profile-list.component.scss"],
  standalone: true,
  imports: [CommonModule, TooltipDirective, TableComponent, TranslateModule],
})
export class DrProfileListComponent {
  constructor() {}

  @Input() totalRecords: number;
  @Input() numberOfRows: number;
  @Input() data: DrProfile[];
  @Output() requestUpdate = new EventEmitter<PaginationModel>();
  @Output() onEdit = new EventEmitter<DrProfile>();

  editRow(row: DrProfile) {
    this.onEdit.emit(row);
  }

  outputPaginationData($event: PaginationModel) {
    this.requestUpdate.emit($event);
  }
}
